$( document ).ready(function() {
  $('.model-box2').on('show.bs.modal', function () {
  // Load up a new modal...
  $('.model-box1').modal('hide');
    
  	var toatal_quantity = $('#Quantity').val(); 
    var wastage_percentage = $(".js-wastage").text();
    var wastage = Math.ceil((wastage_percentage/100) * toatal_quantity);
    var quantity = parseInt(toatal_quantity) - parseInt(wastage);
    $('.js-quantity').val(quantity);
    $('.js-total').text(toatal_quantity);
    
});
  
  $('.js-quantity').on('change', function() {
    var price=$("#ProductMeterPrice").val();
    var quantity = $(".js-quantity").val();
    var wastage_percentage = $(".js-wastage").text();
    var wastage = Math.ceil((wastage_percentage/100) * quantity);
    var toatal_quantity = parseInt(quantity) + parseInt(wastage);
    var total = (price * toatal_quantity).toFixed(2);
    $('.js-total').text(toatal_quantity);
    $("#Quantity").val(toatal_quantity);
    $(".js-product-price").attr("data-price",total);
    $(".js-product-price").text("$"+total);
  
  });
  $(".js-close-modal").on("click", function() { 
  
   $('.model-box2').modal('hide');
    $('.model-box1').modal('hide');
   });
  $('.modal__shapes-link').on("click", function() {
    var wastage = $(this).attr('data-wastage');
    $('.modal__shapes-link').removeClass('is-active');
    $(this).addClass('is-active');
    $('.js-wastage').text(wastage);
    var toatal_quantity = $('#Quantity').val(); 
    var wastage_percentage = $(".js-wastage").text();
    var wastage = Math.ceil((wastage_percentage/100) * toatal_quantity);
    var quantity = parseInt(toatal_quantity) - parseInt(wastage);
    $('.js-quantity').val(quantity);
    $('.js-total').text(toatal_quantity);
  });

});

